import React, { useState, useRef, useEffect } from "react";
import { Form, Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import ModalClass from "./ModalClass";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import useFetchHouses from "../../hooks/useFetchHouses";
import useFetchRoutes from "../../hooks/useFetchRoutes ";
import useFeeGroups from "../../hooks/useFeeGroups";
import useFetchPickupPoints from "../../hooks/useFetchPickupPoints ";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const [formData, setFormData] = useState({
    classId: "",
    sectionId: "",
    routeid: "",
    selectedPickUpPoint: "",
    feeappfrom: "", // Initial value for Fee App From
    feegroup: "",
  });
  const [selectedClassId, setSelectedClassId] = useState("");
  const navigate = useNavigate();

  // Fetch classes data
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // You can change this to show more/less per page
  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(formData.classId);
  const [studentsData, setStudentsData] = useState([]);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentStudents = studentsData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(studentsData.length / itemsPerPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1); // react-paginate gives 0-based index
  };

  // Helper function to convert status values to ACTIVE/INACTIVE
  const getStatusText = (student) => {
    // Check for various possible status field names
    const statusValue = 
      student.is_active !== undefined ? student.is_active :
      student.active !== undefined ? student.active :
      student.status !== undefined ? student.status :
      student.student_status !== undefined ? student.student_status :
      true; // Default to true (ACTIVE) if no status field found

    // Convert value to boolean and display
    if (statusValue === true || statusValue === 1 || statusValue === "Active" || statusValue === "ACTIVE" || statusValue === "true") {
      return "ACTIVE";
    } else if (statusValue === false || statusValue === 0 || statusValue === "Inactive" || statusValue === "INACTIVE" || statusValue === "false") {
      return "INACTIVE";
    }
    
    return "ACTIVE"; // Default to ACTIVE
  };

  const [amount, setAmount] = useState("");
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [isTransportAvailed, setIsTransportAvailed] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);
  const {
    pickupPoints,
    loading: pickupLoading,
    error: pickupError,
  } = useFetchPickupPoints(formData.routeid);
  const {
    routes,
    loading: routeLoading,
    error: routeError,
  } = useFetchRoutes(isTransportAvailed);
  const [selectedPickUpPoint, setSelectedPickUpPoint] = useState("");

  const [showStudentSelectionModal, setShowStudentSelectionModal] =
    useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const studentNameRef = useRef(null);
  const [periods, setPeriods] = useState([]);
  const {
    houses,
    loading: loadingHouses,
    error: errorHouses,
  } = useFetchHouses();
  const [selectedStudent, setSelectedStudent] = useState(null);
  const {
    feeGroups = [],
    loading: feeLoading,
    error: feeError,
  } = useFeeGroups(formData.classId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  // Function to close the modal
  const modalClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (routes.length > 0 && selectedStudent?.routeid) {
      const routeExists = routes.some(
        (route) => String(route.id) === String(selectedStudent.routeid)
      );
      if (routeExists) {
        setSelectedRoute(String(selectedStudent.routeid));
      } else {
        setSelectedRoute("");
      }
    }
  }, [routes, selectedStudent]);

  // Synchronize form data with student data when editing
  useEffect(() => {
    if (selectedStudent) {
      setFormData((prev) => ({
        ...prev,
        routeid: selectedStudent.routeid || "",
        selectedPickUpPoint: selectedStudent.pickuppoitId || "",
      }));

      setIsTransportAvailed(selectedStudent.transport_availed || false);
      setSelectedPickUpPoint(selectedStudent.pickuppoitId || "");
    }
  }, [selectedStudent]);

  // Synchronize selectedPickUpPoint when pickupPoints are fetched
  useEffect(() => {
    if (pickupPoints.length > 0 && formData.selectedPickUpPoint) {
      const matchingPoint = pickupPoints.find(
        (point) =>
          String(point.routeDetailsId) === String(formData.selectedPickUpPoint) ||
          point.pickup_point_name === selectedStudent?.pickuppointname
      );

      if (matchingPoint) {
        setFormData((prev) => ({
          ...prev,
          selectedPickUpPoint: String(matchingPoint.routeDetailsId),
        }));
        setSelectedPickUpPoint(String(matchingPoint.routeDetailsId));
      } else {
        setSelectedPickUpPoint("");
      }
    }
  }, [pickupPoints, formData.selectedPickUpPoint]);

  //08252025
  // const handleEditClick = (student) => {
  //   const academicSessionId = localStorage.getItem("academicSessionId");

  //   //  Reset everything before opening modal
  //   setFormData({
  //     classId: "",
  //     sectionId: "",
  //     routeid: "",
  //     selectedPickUpPoint: "",
  //     feeappfrom: "",
  //     feegroup: "",
  //     rollno: "",
  //     house: "",
  //     choice_month: [],
  //     amount: "",
  //   });
  //   setIsTransportAvailed(false);
  //   setSelectedRoute("");
  //   setSelectedPickUpPoint("");
  //   setSelectedMonths({});
  //   setSelectedStudent(null);

  //   // Now show the modal
  //   setShowEditModal(true);

  //   // Fetch student data fresh
  //   fetch(
  //     `${ApiUrl.apiurl}STUDENT_CLASS/GetStudentDataBasedId/${student.studentId}?academic_year_id=${academicSessionId}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.message === "Success") {
  //         const studentData = data.data;

  //         localStorage.setItem("studentData", JSON.stringify(studentData));

  //         // Update selectedStudent state
  //         setSelectedStudent({
  //           studentname: studentData.studentname,
  //           school_admission_no: studentData.school_admission_no,
  //           barcode: studentData.barcode,
  //           father_name: studentData.father_name,
  //           mother_name: studentData.mother_name,
  //           classname: studentData.classname,
  //           sectionname: studentData.sectionname,
  //           rollno: studentData.rollno,
  //           house: studentData.house,
  //           fee_structure_master: studentData.fee_structure_master,
  //           feeappfrom: studentData.feeappfrom,
  //           transport_availed: studentData.transport_availed || false,
  //           choice_month: studentData.choice_month || [],
  //           routeid: studentData.routeid,
  //           transport_name: studentData.transport_name,
  //           pickuppoitId: studentData.pickuppoitId,
  //           pickuppointname: studentData.pickuppointname,
  //           selectedRoute: studentData.routeid || "",
  //           selectedPickUpPoint: studentData.pickuppoitId,
  //           amount: studentData.amount,
  //         });

  //         //  Prepare all 12 months (unchecked by default)
  //         const allMonths = Array.from({ length: 12 }, (_, i) => i + 1);
  //         const selectedIds = (studentData.choice_month || []).map((m) => m.id);

  //         //  Map house name from API response to house.id
  //         const matchingHouse = houses.find(
  //           (h) => h.housename.toLowerCase() === (studentData.house || "").toLowerCase()
  //         );

  //         // Update formData with 12 months
  //         setFormData({
  //           classId: studentData.classId,
  //           sectionId: studentData.sectionId,
  //           rollno: studentData.rollno,
  //           // house: studentData.house,
  //           house: matchingHouse ? matchingHouse.id : "",  // ✅ Use house.id
  //           feegroup: studentData.fee_structure_masterId,
  //           feeappfrom: studentData.feeappfromId,
  //           routeid: studentData.routeid || "",
  //           selectedPickUpPoint: studentData.pickuppoitId || "",
  //           amount: studentData.amount || "",
  //           choice_month: allMonths.map((id) => ({
  //             id,
  //             checked: selectedIds.includes(id),
  //           })),
  //         });

  //         // Update transport + months object
  //         setIsTransportAvailed(studentData.transport_availed || false);
  //         setSelectedRoute(studentData.routeid || "");
  //         setSelectedPickUpPoint(studentData.pickuppoitId || "");
  //         setSelectedMonths(
  //           allMonths.reduce((acc, id) => {
  //             acc[id] = selectedIds.includes(id);
  //             return acc;
  //           }, {})
  //         );
  //       } else {
  //         alert("Error fetching student data");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching student data:", error);
  //       alert("Error fetching student data");
  //     });
  // };

  //09092025
  // const handleEditClick = (student) => {
  //   const academicSessionId = localStorage.getItem("academicSessionId");

  //   //  Reset everything before opening modal
  //   setFormData({
  //     classId: "",
  //     sectionId: "",
  //     routeid: "",
  //     selectedPickUpPoint: "",
  //     feeappfrom: "",
  //     feegroup: "",
  //     rollno: "",
  //     house: "",
  //     choice_month: [],
  //     amount: "",
  //   });
  //   setIsTransportAvailed(false);
  //   setSelectedRoute("");
  //   setSelectedPickUpPoint("");
  //   setSelectedMonths({});
  //   setSelectedStudent(null);

  //   // Now show the modal
  //   setShowEditModal(true);

  //   //  Fetch student data fresh
  //   fetch(
  //     `${ApiUrl.apiurl}STUDENT_CLASS/GetStudentDataBasedId/${student.studentId}?academic_year_id=${academicSessionId}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.message === "Success") {
  //         const studentData = data.data;

  //         localStorage.setItem("studentData", JSON.stringify(studentData));

  //         //  check if paid
  //         if (studentData.is_paid) {
  //           // disable all except Class, Section, Roll No, House
  //           setIsDisabled(true);
  //         } else {
  //           setIsDisabled(false);
  //         }

  //         // Update selectedStudent state
  //         setSelectedStudent({
  //           studentname: studentData.studentname,
  //           school_admission_no: studentData.school_admission_no,
  //           barcode: studentData.barcode,
  //           father_name: studentData.father_name,
  //           mother_name: studentData.mother_name,
  //           classname: studentData.classname,
  //           sectionname: studentData.sectionname,
  //           rollno: studentData.rollno,
  //           house: studentData.house,
  //           fee_structure_master: studentData.fee_structure_master,
  //           feeappfrom: studentData.feeappfrom,
  //           transport_availed: studentData.transport_availed || false,
  //           choice_month: studentData.choice_month || [],
  //           routeid: studentData.routeid,
  //           transport_name: studentData.transport_name,
  //           pickuppoitId: studentData.pickuppoitId,
  //           pickuppointname: studentData.pickuppointname,
  //           selectedRoute: studentData.routeid || "",
  //           selectedPickUpPoint: studentData.pickuppoitId,
  //           amount: studentData.amount,
  //         });

  //         //  Prepare all 12 months (unchecked by default)
  //         const allMonths = Array.from({ length: 12 }, (_, i) => i + 1);
  //         const selectedIds = (studentData.choice_month || []).map((m) => m.id);

  //         // Map house name from API response to house.id
  //         const matchingHouse = houses.find(
  //           (h) =>
  //             h.housename.toLowerCase() === (studentData.house || "").toLowerCase()
  //         );

  //         // Update formData with 12 months
  //         setFormData({
  //           classId: studentData.classId,
  //           sectionId: studentData.sectionId,
  //           rollno: studentData.rollno,
  //           house: matchingHouse ? matchingHouse.id : "",
  //           feegroup: studentData.fee_structure_masterId,
  //           feeappfrom: studentData.feeappfromId,
  //           routeid: studentData.routeid || "",
  //           selectedPickUpPoint: studentData.pickuppoitId || "",
  //           amount: studentData.amount || "",
  //           choice_month: allMonths.map((id) => ({
  //             id,
  //             checked: selectedIds.includes(id),
  //           })),
  //         });

  //         // Update transport + months object
  //         setIsTransportAvailed(studentData.transport_availed || false);
  //         setSelectedRoute(studentData.routeid || "");
  //         setSelectedPickUpPoint(studentData.pickuppoitId || "");
  //         setSelectedMonths(
  //           allMonths.reduce((acc, id) => {
  //             acc[id] = selectedIds.includes(id);
  //             return acc;
  //           }, {})
  //         );
  //       } else {
  //         alert("Error fetching student data");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching student data:", error);
  //       alert("Error fetching student data");
  //     });
  // };

  //09122025
  const handleEditClick = (student) => {
    const academicSessionId = localStorage.getItem("academicSessionId");

    // Reset everything before opening modal
    setFormData({
      classId: "",
      sectionId: "",
      routeid: "",
      selectedPickUpPoint: "",
      feeappfrom: "",
      feegroup: "",
      rollno: "",
      house: "",
      choice_month: [],
      amount: "",
    });
    setIsTransportAvailed(false);
    setSelectedRoute("");
    setSelectedPickUpPoint("");
    setSelectedMonths({});
    setSelectedStudent(null);

    setShowEditModal(true);

    fetch(
      `${ApiUrl.apiurl}STUDENT_CLASS/GetStudentDataBasedId/${student.studentId}?academic_year_id=${academicSessionId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Success") {
          const studentData = data.data;

          localStorage.setItem("studentData", JSON.stringify(studentData));

          if (studentData.is_paid) {
            setIsDisabled(true);
          } else {
            setIsDisabled(false);
          }

          setSelectedStudent({
            studentname: studentData.studentname,
            school_admission_no: studentData.school_admission_no,
            barcode: studentData.barcode,
            father_name: studentData.father_name,
            mother_name: studentData.mother_name,
            classname: studentData.classname,
            sectionname: studentData.sectionname,
            rollno: studentData.rollno,
            house: studentData.house,
            fee_structure_master: studentData.fee_structure_master,
            feeappfrom: studentData.feeappfrom,
            transport_availed: studentData.transport_availed || false,
            choice_month: studentData.choice_month || [],
            routeid: studentData.routeid,
            transport_name: studentData.transport_name,
            pickuppoitId: studentData.pickuppoitId,
            pickuppointname: studentData.pickuppointname,
            selectedRoute: studentData.routeid || "",
            selectedPickUpPoint: studentData.pickuppoitId,
            amount: studentData.amount,
          });

          //  FIX: use actual periods (from API) instead of hardcoding 1..12
          const allMonths = periods.map((p) => p.id);
          const transportAvailed = Boolean(studentData.transport_availed);
          const selectedIds = transportAvailed
            ? (studentData.choice_month || []).map((month) =>
                typeof month === "object" ? month.id : month
              )
            : [];

          const matchingHouse = houses.find(
            (h) =>
              h.housename.toLowerCase() ===
              (studentData.house || "").toLowerCase()
          );

          setFormData({
            classId: studentData.classId,
            sectionId: studentData.sectionId,
            rollno: studentData.rollno,
            house: matchingHouse ? matchingHouse.id : "",
            feegroup: studentData.fee_structure_masterId,
            feeappfrom: studentData.feeappfromId,
            routeid: studentData.routeid || "",
            selectedPickUpPoint: studentData.pickuppoitId || "",
            amount: studentData.amount || "",
            transport_availed: transportAvailed,
            choice_month: selectedIds,
          });

          //  Correct selected months mapping
          setIsTransportAvailed(transportAvailed);
          setSelectedRoute(studentData.routeid || "");
          setSelectedPickUpPoint(studentData.pickuppoitId || "");
          setSelectedMonths(
            allMonths.reduce((acc, id) => {
              acc[id] = selectedIds.includes(id);
              return acc;
            }, {})
          );
        } else {
          alert("Error fetching student data");
        }
      })
      .catch((error) => {
        console.error("Error fetching student data:", error);
        alert("Error fetching student data");
      });
  };

  // This useEffect hook listens for classId changes to trigger section fetching
  useEffect(() => {
    if (formData.classId) {
      // Trigger the fetching of sections based on classId
      // The useFetchSections hook should automatically re-fetch sections
      // when formData.classId changes.
    }
  }, [formData.classId]);

  const [error, setError] = useState(null);
  const [selectedMonths, setSelectedMonths] = useState({});
  useEffect(() => {
    if (!formData.transport_availed) {
      setSelectedMonths((prev) =>
        Object.keys(prev).reduce((months, monthId) => {
          months[monthId] = false;
          return months;
        }, {})
      );
    }
  }, [formData]);

  // const handleModalClose = () => {
  //   setShowEditModal(false);
  //   setShowStudentSelectionModal(false);
  // };

  const handleModalClose = () => {
    setShowEditModal(false);
    setShowStudentSelectionModal(false);

    // Reset all edit-related states
    setFormData({
      classId: "",
      sectionId: "",
      routeid: "",
      selectedPickUpPoint: "",
      feeappfrom: "",
      feegroup: "",
      rollno: "",
      house: "",
      choice_month: [],
      amount: "",
    });
    setSelectedStudent(null);
    setIsTransportAvailed(false);
    setSelectedRoute("");
    setSelectedPickUpPoint("");
    setSelectedMonths({});
  };

  //new code 08072025
  const handleSaveChanges = () => {
    const loginId = sessionStorage.getItem("userId");
    const org_id = localStorage.getItem("orgId");
    const branch_id = localStorage.getItem("branchId");
    const academic_year_id = localStorage.getItem("academicSessionId");
    const studentData = JSON.parse(localStorage.getItem("studentData"));

    if (!studentData) {
      alert("No student data found");
      return;
    }

    const updatedStudentData = {
      ...studentData,
      ...formData,
    };

    const studentId = updatedStudentData.studentId;

    //  Required field validations
    if (!formData.classId) {
      alert("Admitted Class is required.");
      return;
    }

    if (!formData.sectionId) {
      alert("Admitted Section is required.");
      return;
    }

    if (!formData.feeappfrom) {
      alert("Fee App From is required.");
      return;
    }

    if (!formData.feegroup) {
      alert("Fee Group is required.");
      return;
    }

    //  Transport validation with specific alerts
    if (isTransportAvailed) {
      if (!selectedRoute && !formData.routeid) {
        alert("Route is required when Transport is Availed.");
        return;
      }

      if (!formData.selectedPickUpPoint) {
        alert("Pick Up Point is required when Transport is Availed.");
        return;
      }

      if (!formData.amount || String(formData.amount).trim() === "") {
        alert("Amount is required when Transport is Availed.");
        return;
      }
    }

    const payload = {
      loginId,
      org_id,
      branch_id,
      academic_year_id,
      classId: updatedStudentData.classId,
      sectionId: updatedStudentData.sectionId,
      rollno: updatedStudentData.rollno,
      house: updatedStudentData.house || "",
      feestructureId: updatedStudentData.feegroup || "",
      feeappfromId: updatedStudentData.feeappfrom || "",
      transportavailed: updatedStudentData.transport_availed,
      choicemonthIds: (updatedStudentData.choice_month || []).map((month) =>
        typeof month === "object" ? month.id : month
      ),
      routedetailId: updatedStudentData.selectedPickUpPoint
        ? updatedStudentData.selectedPickUpPoint
        : null,
      amount: updatedStudentData.amount,
      previousyearBalance: updatedStudentData.previousyearBalance || 100,
      updateorconfirm: "U",
      carryordelete: "N",
    };

    fetch(`${ApiUrl.apiurl}STUDENT_CLASS/updatestudentclass/${studentId}/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);

        if (data.message === "Student Update Successfully!!") {
          alert("Student Update Successfully!!");

          localStorage.removeItem("studentData");

          if (typeof handleModalClose === "function") {
            handleModalClose();
          }

          handleSearch();
        } else {
          alert(data.message || "Unknown error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Failed to update student data. Please try again.");
      });
  };

  const handleClear = () => {
    setFormData({ classId: "", sectionId: "" });
    if (studentNameRef.current) {
      studentNameRef.current.value = "";
    }
    localStorage.removeItem("selectedStudentClassId");
    localStorage.removeItem("selectedStudentSectionId");
    localStorage.removeItem("selectedClassStudentId");
    setStudentsData([]);
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;

    if (classId) {
      localStorage.setItem("selectedStudentClassId", classId);
    } else {
      localStorage.removeItem("selectedStudentClassId");
    }

    // Update formData with the new classId and reset sectionId
    setFormData((prev) => ({
      ...prev,
      classId,
      sectionId: "", // Reset section when class changes
    }));

    setSelectedClassId(classId); // Trigger sections fetch with the selected class ID
  };

  const handleSectionChange = (e) => {
    const sectionId = e.target.value;

    if (sectionId) {
      localStorage.setItem("selectedStudentSectionId", sectionId);
    } else {
      localStorage.removeItem("selectedStudentSectionId");
    }

    setFormData((prev) => ({ ...prev, sectionId }));
  };

  // Trigger section fetching whenever selectedClassId changes
  useEffect(() => {
    if (selectedClassId) {
      // Ensure sections are fetched based on selected class
      // Optionally handle loading or error state within the useFetchSections hook
    }
  }, [selectedClassId]);

  // useEffect(() => {
  //   fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
  //     .then((response) =>
  //       response.ok ? response.json() : Promise.reject(response.status)
  //     )
  //     .then((data) => {
  //       setPeriods(data.data || []);
  //       const initialMonths = (data.data || []).reduce((acc, period) => {
  //         acc[period.id] = false;
  //         return acc;
  //       }, {});
  //       setSelectedMonths(initialMonths);
  //     })
  //     .catch(() => setError("Failed to load periods."));
  // }, []);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
      .then((response) =>
        response.ok ? response.json() : Promise.reject(response.status)
      )
      .then((data) => {
        setPeriods(data.data || []);
        const initialMonths = (data.data || []).reduce((acc, period) => {
          acc[period.id] = false;
          return acc;
        }, {});
        setSelectedMonths(initialMonths);
      })
      .catch(() => setError("Failed to load periods."));
  }, []);

  useEffect(() => {
    if (!selectedStudent || periods.length === 0) return;

    const selectedIds = selectedStudent.transport_availed
      ? (selectedStudent.choice_month || []).map((month) =>
          typeof month === "object" ? month.id : month
        )
      : [];

    setSelectedMonths(
      periods.reduce((months, period) => {
        months[period.id] = selectedIds.includes(period.id);
        return months;
      }, {})
    );
  }, [periods, selectedStudent]);

  // Auto-load student list on component mount and when Academic Session changes
  useEffect(() => {
    const academicSessionId = localStorage.getItem("academicSessionId");
    
    if (academicSessionId) {
      // Call handleSearch to auto-load student list with default Academic Session
      handleSearch();
    }
  }, []);

  // Monitor Academic Session changes and reload student list
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "academicSessionId") {
        // Clear existing data and reload when session changes
        setStudentsData([]);
        setCurrentPage(1);
        
        // Auto-fetch with new session
        const newSessionId = localStorage.getItem("academicSessionId");
        if (newSessionId) {
          handleSearch();
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleSearch = async () => {
    const academicYearId = localStorage.getItem("academicSessionId");
    const selectedClassId = localStorage.getItem("selectedStudentClassId");
    const selectedSectionId = localStorage.getItem("selectedStudentSectionId");
    const selectedClassStudentId = localStorage.getItem(
      "selectedClassStudentId"
    );

    if (!academicYearId) {
      alert("Academic Year ID is required.");
      return;
    }

    let apiUrl = `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSRECORDFILTER/?academic_year_id=${academicYearId}`;

    if (selectedClassId) apiUrl += `&classId=${selectedClassId}`;
    if (selectedSectionId) apiUrl += `&sectionId=${selectedSectionId}`;
    if (selectedClassStudentId)
      apiUrl += `&studentId=${selectedClassStudentId}`;

    console.log("Constructed API URL:", apiUrl);

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json();
      console.log("API Response:", result);

      if (result.message === "success!!" && result.data) {
        setStudentsData(result.data);
      } else {
        alert("No data found.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("An error occurred while fetching data.");
    }
  };

  const handleInputChange = (e) => {
    if (isDisabled) return;

    const { name, value } = e.target;

    if (name === "house") {
      if (value) {
        localStorage.setItem("selectedHouseId", value);
      } else {
        localStorage.removeItem("selectedHouseId");
      }
    }

    if (name === "feeappfrom") {
      if (value) {
        localStorage.setItem("selectedFeeAppFromId", value);
      } else {
        localStorage.removeItem("selectedFeeAppFromId");
      }
    }

    if (name === "feegroup") {
      if (value) {
        localStorage.setItem("selectedFeeGroupId", value);
      } else {
        localStorage.removeItem("selectedFeeGroupId");
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleTransportAvailedChange = () => {
    const newValue = !isTransportAvailed;
    setIsTransportAvailed(newValue);

    const monthIds = periods.length
      ? periods.map((period) => period.id)
      : Object.keys(selectedMonths).map((monthId) => parseInt(monthId));
    const updatedMonths = monthIds.reduce((acc, monthId) => {
      acc[monthId] = newValue;
      return acc;
    }, {});

    setSelectedMonths(updatedMonths);

    const selectedMonthIds = Object.keys(updatedMonths)
      .filter((month) => updatedMonths[month])
      .map((month) => parseInt(month));

    setFormData((prevData) => ({
      ...prevData,
      transport_availed: newValue,
      choice_month: selectedMonthIds,
    }));

    localStorage.setItem("transport_availed", JSON.stringify(newValue));

    if (newValue) {
      localStorage.setItem("choice_month", JSON.stringify(selectedMonthIds));
    } else {
      localStorage.removeItem("choice_month");
    }
  };

  const handleMonthChange = (monthId) => {
    setSelectedMonths((prev) => {
      const updatedMonths = {
        ...prev,
        [monthId]: !prev[monthId], // Toggle the specific month's checked state
      };

      const selectedMonthIds = Object.keys(updatedMonths)
        .filter((month) => updatedMonths[month])
        .map((month) => parseInt(month));

      setFormData((prevData) => ({
        ...prevData,
        choice_month: selectedMonthIds,
      }));

      if (isTransportAvailed) {
        localStorage.setItem("choice_month", JSON.stringify(selectedMonthIds));
      }

      return updatedMonths;
    });
  };

  const handleRouteChange = (e) => {
    const selectedRouteId = e.target.value;
    console.log("Selected Route ID:", selectedRouteId); // Check if this value is being correctly set

    if (!selectedRouteId) {
      localStorage.removeItem("selectedRouteId");
      setSelectedRoute("");
      setFormData((prevData) => ({
        ...prevData,
        routeid: "", // Ensure you are using the correct key here
      }));
    } else {
      localStorage.setItem("selectedRouteId", selectedRouteId);
      setSelectedRoute(selectedRouteId);
      setFormData((prevData) => ({
        ...prevData,
        routeid: selectedRouteId, // Ensure this key matches the expected 'routeid'
      }));
    }
  };

  useEffect(() => {
    const savedRouteId = localStorage.getItem("selectedRouteId");
    if (savedRouteId) {
      setSelectedRoute(savedRouteId);
      setFormData((prev) => ({
        ...prev,
        route_id: savedRouteId,
      }));
    }
  }, []);

  // const handlePickUpPointChange = (e) => {
  //   if (isDisabled) return;

  //   const selectedPickupPointId = e.target.value;

  //   if (!selectedPickupPointId) {
  //     localStorage.removeItem("selectedPickUpPointId");
  //     setSelectedPickUpPoint("");
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       selectedPickUpPoint: "",
  //     }));
  //   } else {
  //     localStorage.setItem("selectedPickUpPointId", selectedPickupPointId);
  //     setSelectedPickUpPoint(selectedPickupPointId);
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       selectedPickUpPoint: selectedPickupPointId,
  //     }));
  //   }
  // };

  //08252025
  const handlePickUpPointChange = (e) => {
    const selectedPickupPointId = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      selectedPickUpPoint: selectedPickupPointId || "",
    }));

    if (selectedPickupPointId) {
      localStorage.setItem("selectedPickUpPointId", selectedPickupPointId);
    } else {
      localStorage.removeItem("selectedPickUpPointId");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT CLASS
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={handleSearch}
                    style={{
                      width: "150px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{
                      width: "150px",
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    onClick={() => navigate("/admin/dashboard")}
                    style={{
                      width: "150px",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mb-3 mt-3">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            ref={studentNameRef}
                            disabled={isInputDisabled} // Dynamically control the disabled state
                            onInput={(e) => {
                              if (!e.target.value.trim()) {
                                localStorage.removeItem(
                                  "selectedClassStudentId"
                                );
                              }
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={() => setShowStudentSelectionModal(true)}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      {/* <ModalClass
                        show={showStudentSelectionModal}
                        handleClose={handleModalClose}
                        onSelectStudent={(student) => {
                          const studentDetails = student.studentBasicDetails;
                          const studentId = studentDetails.id;

                          studentNameRef.current.value = `${studentDetails.first_name
                            } ${studentDetails.middle_name || ""} ${studentDetails.last_name
                            }`;

                          setFormData((prev) => ({
                            ...prev,
                            studentId: studentId,
                          }));

                          handleModalClose();
                        }}
                      /> */}

                      <ModalClass
                        show={showStudentSelectionModal}
                        handleClose={handleModalClose}
                        onSelectStudent={(student) => {
                          //  Use studentId from API (fallback to id just in case)
                          const studentId = student.studentId || student.id;

                          //  Directly use studentname (already provided by API)
                          studentNameRef.current.value =
                            student.studentname || "";

                          //  Update formData with selected studentId
                          setFormData((prev) => ({
                            ...prev,
                            studentId: studentId,
                          }));

                          handleModalClose();
                        }}
                      />

                      <div className="col-12 col-md-4 mb-3">
                        <label htmlFor="admitted-class" className="form-label">
                          Class<span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          inputId="admitted-class"
                          className="detail"
                          classNamePrefix="react-select"
                          options={classes.map((classItem) => ({
                            value: classItem.id,
                            label: classItem.classname,
                          }))}
                          value={
                            formData.classId
                              ? {
                                  value: formData.classId,
                                  label:
                                    classes.find(
                                      (c) => c.id === formData.classId
                                    )?.classname || "",
                                }
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleClassChange({
                              target: {
                                name: "classId",
                                value: selectedOption?.value || "",
                              },
                            })
                          }
                          placeholder="Select Class"
                        />
                      </div>
                      {/* Admitted Section */}

                      <div className="col-12 col-md-4 mb-2">
                        <label
                          htmlFor="admitted-section"
                          className="form-label"
                        >
                          Admitted Section{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          inputId="admitted-section"
                          className="detail"
                          classNamePrefix="react-select"
                          options={sections.map((section) => ({
                            value: section.section_id,
                            label: section.sectionname,
                          }))}
                          value={
                            formData.sectionId
                              ? {
                                  value: formData.sectionId,
                                  label:
                                    sections.find(
                                      (s) => s.section_id === formData.sectionId
                                    )?.sectionname || "",
                                }
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleSectionChange({
                              target: {
                                name: "sectionId",
                                value: selectedOption?.value || "",
                              },
                            })
                          }
                          placeholder="Select Section"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered" id="studentclassid">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Student Name</th>
                        <th>BarCode</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Father Name</th>
                        <th>Mother Name</th>
                        <th>House</th>
                        <th>Status</th>
                        <th>Transport Availed</th>

                        <th>Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentStudents.length > 0 ? (
                        currentStudents.map((student, index) => (
                          <tr key={student.id}>
                            <td>{indexOfFirstItem + index + 1}</td>{" "}
                            {/*  keeps serial numbers correct */}
                            <td>{student.studentname}</td>
                            <td>{student.barcode}</td>
                            <td>{student.classname}</td>
                            <td>{student.sectionname}</td>
                            <td>{student.father_name}</td>
                            <td>{student.mother_name}</td>
                            <td>{student.house}</td>
                            <td style={{ textAlign: "center" }}>{getStatusText(student)}</td>
                            <td>{student.transport_availed ? "Yes" : "No"}</td>
                            <td>
                              <button
                                className="btn btn-warning"
                                onClick={() => handleEditClick(student)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No students found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={
                      "pagination justify-content-center mt-3"
                    }
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                    forcePage={currentPage - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Student Modal */}
      {showEditModal && selectedStudent && (
        <div className="modal show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-scrollable modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Student Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalClose}
                ></button>
              </div>

              <div className="modal-body">
                {/* <div className="row mb-3">
                  <div
                    className="col-12 text-center"
                    style={{ border: "1px solid #ccc" }}
                  ></div>
                </div> */}
                <div className="row mb-3">
  <div
    className="col-12"
    // style={{
    //   border: "1px solid #ccc",
    //   padding: "8px 15px",
    //   background: "#fff",
    // }}
  >
    {/* <h5 className="mb-0">Student Details</h5> */}
  </div>
</div>

                <div className="row mb-4">
  <div
    className="col-12 py-2 px-3"
    style={{
      border: "1px solid #ccc",
      background: "#fafafa",
    }}
  >
    <h5 className="mb-0 fw-bold">
      Student Details
    </h5>
  </div>
</div>

<div className="row g-3 mb-4">
                  <div className="col-12 col-md-3 mb-2">
                    <label className="form-label">Student Name</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.studentname}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-2">
                    <label className="form-label">Student Barcode</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.barcode}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-2">
                    <label className="form-label">Father Name</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.father_name}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-2">
                    <label className="form-label">Mother Name</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.mother_name}
                      disabled
                    />
                  </div>
                </div>

                <div className="row mt-3 mb-4">
  <div
    className="col-12 py-2 px-3"
    style={{
      border: "1px solid #ccc",
      background: "#fafafa",
    }}
  >
    <h5 className="mb-0 fw-bold">
      Student Class Details
    </h5>
  </div>
</div>

<div className="row g-3 mb-4">
                  <div className="col-12 col-md-3 mb-2">
                    <label htmlFor="admitted-class" className="form-label">
                      Admitted Class<span style={{ color: "red" }}>*</span>
                    </label>
                    {classLoading ? (
                      <p>Loading classes...</p>
                    ) : classError ? (
                      <p style={{ color: "red" }}>
                        Error loading classes: {classError}
                      </p>
                    ) : (
                      <select
                        id="admitted-class"
                        className="form-select"
                        value={formData.classId}
                        onChange={handleClassChange}
                        required
                      >
                        <option value="">Select Class</option>
                        {classes.map((classItem) => (
                          <option key={classItem.id} value={classItem.id}>
                            {classItem.classname}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>

                  <div className="col-12 col-md-3 mb-2">
                    <label htmlFor="admitted-section" className="form-label">
                      Admitted Section <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      inputId="admitted-section"
                      classNamePrefix="react-select"
                      options={sections.map((section) => ({
                        value: section.section_id,
                        label: section.sectionname,
                      }))}
                      value={
                        sections.find(
                          (s) => s.section_id === formData.sectionId
                        ) || null
                          ? {
                              value: formData.sectionId,
                              label:
                                sections.find(
                                  (s) => s.section_id === formData.sectionId
                                )?.sectionname || "",
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleSectionChange({
                          target: {
                            name: "sectionId",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      placeholder="Select Section"
                    />
                  </div>

                  <div className="col-12 col-md-3 mb-2">
                    <label htmlFor="rollno" className="form-label">
                      Roll No
                    </label>
                    <input
                      type="text"
                      id="rollno"
                      className="form-control detail"
                      placeholder="Enter roll-no"
                      value={formData.rollno}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          rollno: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-2">
                    <label htmlFor="house" className="form-label">
                      House
                    </label>
                    <select
                      id="house"
                      className="form-select"
                      name="house"
                      value={formData.house}
                      onChange={handleInputChange}
                    >
                      <option value="">Select house</option>
                      {loadingHouses && <option>Loading houses...</option>}
                      {errorHouses && <option>Error loading houses</option>}
                      {!loadingHouses &&
                        !errorHouses &&
                        houses.map((house) => (
                          <option key={house.id} value={house.id}>
                            {house.housename}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 border">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-6 mb-1">
                        <label htmlFor="fee-app-from" className="form-label">
                          Fee App From<span style={{ color: "red" }}>*</span>
                        </label>
                        {error ? (
                          <p style={{ color: "red" }}>{error}</p>
                        ) : (
                          <select
                            id="fee-app-from"
                            className="form-select"
                            value={formData.feeappfrom}
                            onChange={handleInputChange}
                            name="feeappfrom"
                            disabled={isDisabled}
                          >
                            <option value="">Select Fee App From</option>
                            {periods.map((period) => (
                              <option key={period.id} value={period.id}>
                                {period.period_name}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>

                      <div className="col-12 col-md-6 mb-2">
                        <label htmlFor="fee-group" className="form-label">
                          Fee Group<span style={{ color: "red" }}>*</span>
                        </label>
                        {feeLoading ? (
                          <p>Loading fee groups...</p>
                        ) : feeError ? (
                          <p style={{ color: "red" }}>
                            Error loading fee groups: {feeError}
                          </p>
                        ) : (
                          <select
                            id="fee-group"
                            className="form-select"
                            value={formData.feegroup} // Map to formData.feegroup
                            onChange={handleInputChange}
                            name="feegroup"
                            disabled={isDisabled}
                          >
                            <option value="">Select Fee Group</option>
                            {feeGroups.length > 0 ? (
                              feeGroups.map((feeGroup) => (
                                <option key={feeGroup.id} value={feeGroup.id}>
                                  {feeGroup.feestructuredesc}
                                </option>
                              ))
                            ) : (
                              <option value="" disabled>
                                No fee groups available
                              </option>
                            )}
                          </select>
                        )}
                      </div>
                    </div>
                    <div
  className="col-12 py-2 px-3 mt-4 mb-3"
  style={{
    border: "1px solid #ccc",
    background: "#fafafa",
  }}
>
  <h5 className="mb-0 fw-bold">
    Transport Details
  </h5>
</div>
                    {/* <Form.Check
                      type="checkbox"
                      className="mb-3 d-flex align-items-center"
                      style={{ fontWeight: "700" }}
                      checked={isTransportAvailed} // This should reflect the state value
                      onChange={handleTransportAvailedChange}
                      disabled={false}
                      label={
                        <span style={{ marginLeft: "10px" }}>
                          Transport Availed
                        </span>
                      }
                    /> */}

                    <Form.Check
                      type="checkbox"
                      className="mb-3 d-flex align-items-center"
                      style={{ fontWeight: "700" }}
                      checked={isTransportAvailed} // Reflects the state value
                      onChange={handleTransportAvailedChange}
                      disabled={false}
                      label={
                        <span style={{ marginLeft: "10px" }}>
                          Transport Availed
                        </span>
                      }
                    />

                    {/* <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        padding: "10px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      {Object.keys(selectedMonths).map((monthId) => (
                        <div
                          key={monthId}
                          style={{
                            flex: "1 1 calc(25% - 10px)",
                            minWidth: "100px",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            id={`month-checkbox-${monthId}`}
                            label={
                              periods.find(
                                (period) => period.id === parseInt(monthId)
                              )?.period_name || `Month ${monthId}`
                            }
                            checked={selectedMonths[monthId] || false}
                            onChange={() => handleMonthChange(monthId)}
                            disabled={!isTransportAvailed || isDisabled}
                          />
                        </div>
                      ))}
                    </div> */}

                    {/* <div
  style={{
    maxHeight: "200px",
    overflowY: "auto",
    border: "1px solid #ccc",
    padding: "10px",
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
  }}
>
  {Object.keys(selectedMonths).map((monthId) => (
    <div
      key={monthId}
      style={{
        flex: "1 1 calc(25% - 10px)",
        minWidth: "100px",
      }}
    >
      <Form.Check
        type="checkbox"
        id={`month-checkbox-${monthId}`}
        label={
          periods.find((period) => period.id === parseInt(monthId))
            ?.period_name || `Month ${monthId}`
        }
        checked={selectedMonths[monthId] || false}
        onChange={() => handleMonthChange(monthId)}
        disabled={!isTransportAvailed || isDisabled}
      />
    </div>
  ))}
</div> */}

                    {/* <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        padding: "10px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      {Object.keys(selectedMonths).map((monthId) => (
                        <div
                          key={monthId}
                          style={{
                            flex: "1 1 calc(25% - 10px)",
                            minWidth: "100px",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            id={`month-checkbox-${monthId}`}
                            label={
                              periods.find(
                                (period) => period.id === parseInt(monthId)
                              )?.period_name || `Month ${monthId}`
                            }
                            checked={selectedMonths[monthId] || false}
                            onChange={() => handleMonthChange(monthId)}
                            disabled={!isTransportAvailed || isDisabled}
                          />
                        </div>
                      ))}
                    </div> */}

                    <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        padding: "10px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      {Object.keys(selectedMonths).map((monthId) => (
                        <div
                          key={monthId}
                          style={{
                            flex: "1 1 calc(25% - 10px)",
                            minWidth: "100px",
                          }}
                        >
                          {/* <Form.Check
              type="checkbox"
              id={`month-checkbox-${monthId}`}  // Unique ID for accessibility
              label={periods.find(period => period.id === parseInt(monthId))?.period_name || `Month ${monthId}`} // Default fallback label
              checked={selectedMonths[monthId] || false}
              onChange={() => handleMonthChange(monthId)}
              disabled={!isTransportAvailed || isDisabled}
            /> */}

                          <Form.Check
                            type="checkbox"
                            id={`month-checkbox-${monthId}`} // Unique ID for accessibility
                            label={
                              periods.find(
                                (period) => period.id === parseInt(monthId)
                              )?.period_name || `Month ${monthId}`
                            } // Fallback label
                            checked={selectedMonths[monthId] || false}
                            onChange={() => handleMonthChange(monthId)}
                            disabled={!isTransportAvailed}
                          />
                        </div>
                      ))}
                    </div>

                    <Row className="mt-3">
                      <Col md={6} className="mb-2">
                        <Form.Group controlId="formRoute">
                          <Form.Label>Route</Form.Label>
                          <Form.Select
                            onChange={handleRouteChange}
                            disabled={!isTransportAvailed}
                            value={selectedRoute || ""} // Ensure fallback to empty string
                          >
                            <option value="">Select Route</option>
                            {routeLoading && <option>Loading...</option>}
                            {routeError && (
                              <option>Error loading routes</option>
                            )}
                            {!routeLoading &&
                              !routeError &&
                              routes.map((route) => (
                                <option key={route.id} value={route.id}>
                                  {route.transportname}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-2">
                        <Form.Group controlId="formPickUpPoint">
                          <Form.Label>Pick Up Point</Form.Label>
                          {/* <Form.Select
                            onChange={handlePickUpPointChange}
                            disabled={
                              !isTransportAvailed ||
                              !formData.routeid
                            }
                            value={selectedPickUpPoint || ""}
                          >
                            <option value="">Select Pick Up Point</option>
                            {pickupLoading && <option>Loading...</option>}
                            {pickupError && (
                              <option>
                                Error loading pick-up points: {pickupError}
                              </option>
                            )}
                            {!pickupLoading &&
                              !pickupError &&
                              pickupPoints.map((pickupPoint) => (
                                <option
                                  key={pickupPoint.routeDetailsId} // Ensure correct key
                                  value={pickupPoint.routeDetailsId} // Ensure value is mapped correctly
                                >
                                  {pickupPoint.pickup_point_name}{" "}
                                </option>
                              ))}
                          </Form.Select> */}
                          <Form.Select
                            onChange={handlePickUpPointChange}
                            disabled={
                              !isTransportAvailed ||
                              !formData.routeid
                            }
                            value={formData.selectedPickUpPoint || ""} //  use only formData
                          >
                            <option value="">Select Pick Up Point</option>
                            {pickupLoading && <option>Loading...</option>}
                            {pickupError && (
                              <option>
                                Error loading pick-up points: {pickupError}
                              </option>
                            )}
                            {!pickupLoading &&
                              !pickupError &&
                              pickupPoints.map((pickupPoint) => (
                                <option
                                  key={pickupPoint.routeDetailsId}
                                  value={pickupPoint.routeDetailsId}
                                >
                                  {pickupPoint.pickup_point_name}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="amount" className="form-label">
                          Amount
                        </label>
                        <input
                          type="text"
                          id="amount"
                          value={formData.amount || ""} // Bind the amount here
                          onChange={(e) =>
                            setFormData({ ...formData, amount: e.target.value })
                          }
                          disabled={!isTransportAvailed}
                          className="form-control detail"
                          placeholder="Enter amount"
                          // disabled={!isTransportAvailed}
                          onInput={(e) => {
                            const numericValue = e.target.value.replace(
                              /[^0-9.]/g,
                              ""
                            );
                            setAmount(numericValue);
                          }}
                        />
                      </div>

                      {/* Radio Buttons for Carry Forward and Write Off */}
                    </Row>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleModalClose}
                >
                  Close
                </button>
                {/* <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalClose}
                >
                  Clear
                </button> */}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSaveChanges}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdmAttendanceEntry;
